<template>
  <!-- Begin Header -->
  <header id="ep__header" class="header w-100" :style="{ top: -this.top + 'px' }">
      <div class="d-flex justify-content-between align-items-center">
          <!-- Header Left -->
          <div class="header__left">
              <router-link :to="`/${currentFlag.countryCode.toLowerCase()}`"><img src="@static/img/logo.svg" alt="" /></router-link>
          </div>
          <!-- Header Right -->
          <div class="header__right d-flex align-items-center">
              <!-- Contact us Btn -->
              <router-link :to="`/${currentFlag.countryCode.toLowerCase()}/contact-us`" class="header__button text-decoration-none"><img src="@static/img/phone.svg" alt="">Contact us</router-link>
              <!-- Choose Country / Language -->
              <div class="header__form d-flex align-items-center">
                  <div>Country</div>
                  <EpDropdown
                    :items="supportedCountries"
                    itemKey="countryCode"
                    :selectedItem="currentFlag"
                    @update:selectedItem="handleFlagChange"
                    dropdownClass="flag-dropdown"
                  >
                    <template #selectedItem="{ selectedItem }">
                      <div class="country-dropdown-trigger">
                        <img
                          :src="getFlagUrl(selectedItem.countryCode)"
                          :alt="selectedItem.countryValue"
                          width="32"
                          class="area-code"
                        />
                        <img
                          src="@static/img/dropdown.svg"
                          alt=""
                          class="img-24 ml-8"
                        />
                      </div>
                    </template>

                     <template #item="{ item }">
                      <img :src="getFlagUrl(item.countryCode)" :alt="item.countryValue" width="32" class="mr-16 area-code" />
                      {{ item.countryValue }}
                    </template>
                  </EpDropdown>
                  <div class="header__label">Language</div>
                  <span class="header__lang">{{ displayLanguage.toUpperCase() }}</span>
                  <slot name="header-right"></slot>
              </div>
          </div>
      </div>
  </header>
</template>

<script>
/* istanbul ignore file */
import EpDropdown from '@/components/EpDropdown.vue'
import { getGlobalConfig } from '@/utils/globalConfig'
import { getAssetUrl } from '@/utils/getAssetUrl'

export default {
  name: 'Header',

  components: { EpDropdown },

  props: {
    currentFlag: {
      type: Object,
      default: () => ({
        countryCode: 'SG',
        countryValue: 'Singapore'
      })
    },
    flagList: {
      type: Array,
      require: true
    }
  },

  computed: {
    displayLanguage () {
      const languageCode = this.languageCode || 'EN'
      return languageCode.toLowerCase()
    },
    supportedCountries () {
      const supportedCountries = getGlobalConfig('supportedCountries')
      if (supportedCountries) {
        return supportedCountries[this.displayLanguage]
      }
      return this.flagList
    }
  },

  data () {
    return {
      top: null,
      headerRange: 16
    }
  },

  mounted () {
    window.onscroll = this.handleScroll
  },

  destroyed () {
    window.onscroll = null
  },

  methods: {
    getGlobalConfig,
    switchFlag (country) {
      this.$emit('flagChange', country)
    },

    handleFlagChange (item) {
      this.$logger.info('Changing country', { country: item.countryCode })
      this.switchFlag(item.countryCode)
    },

    handleScroll () {
      if (window.pageYOffset > this.headerRange) {
        document.getElementById('ep__header').classList.add('header__sticky')
        this.calculatePosition()
      } else {
        document.getElementById('ep__header').classList.remove('header__sticky')
        this.top = null
      }
    },

    calculatePosition () {
      if (window.pageYOffset > this.headerRange && window.pageYOffset < this.headerRange * 2) {
        this.top = Math.round(window.pageYOffset - this.headerRange * 2) * -1
      } else {
        this.top = null
      }
    },
    getFlagUrl (countryCode) {
      return getAssetUrl(`/images/flags/3x2/${countryCode.toUpperCase()}.svg`)
    }
  }
}
</script>

<style lang="scss">
  .flag-dropdown {
    z-index: 1000;
  }

  .country-dropdown-trigger {
    padding: 0.375rem 1rem;
    &:hover {
      cursor: pointer;
    }
  }

  .country-code-container {
    display: flex;
    align-items: center;
  }

  .country-code-wrapper {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header__language_container {
    padding-left: 12px;
  }

  .area-code {
    border-radius: 3px;
    padding: 1px;
    border: 1px solid #ebebeb;
  }
</style>
